<script setup lang="ts">
  import { MyAccountRoute } from "@/constants/routes/myAccount"
  import { computed } from "vue"
  import { useRoute, useRouter } from "vue-router"
  import MaintenanceBanner from "@/components/shared/maintenance-banner/MaintenanceBanner.vue"
  import { PageHeader } from "@/components/ui/page-header"

  const router = useRouter()
  const route = useRoute()
  const title = computed(() => (route.meta?.title as string) || "")
  const hideBackButton = computed(
    () => !!(route.meta?.hideBackButton as boolean),
  )
</script>

<template>
  <main class="container space-y-6 px-6">
    <PageHeader
      v-if="title"
      :title="title"
      :has-back-button="!hideBackButton"
      class="mb-6"
      @back="router.push(MyAccountRoute.home)"
    />
    <MaintenanceBanner />
    <slot />
  </main>
</template>
<style scoped>
  main {
    padding-top: max(theme(spacing.6), env(safe-area-inset-top));
    padding-bottom: max(theme(spacing.12), env(safe-area-inset-bottom));
  }
</style>
